<div class="loadingBox" *ngIf="!loaded">
  <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
 </div>
 <div *ngIf="loaded">
<section class="login-main-wrapper full-height">
  <div class="container-fluid pl-0 pr-0">
     <div class="row no-gutters row justify-content-center ">
        <div class="col-md-5 p-5 bg-dark-style authbox">
             <div class="login-main-left">
                <div class="text-center mb-5 login-main-left-header">
                   <img src="assets/img/hostbrand/core-logo.svg" width="200" class="img-fluid" alt="LOGO">
                   
                     </div>
                <form class="example-form">
                    <h2>Confirm Subscription</h2>
                  <div class="form-group">
                      <div class="form-group">
                          <label i18n="@@One Time Pin (OTP) | One Time Pin (OTP) Label"  class="control-label">One Time Pin (OTP)</label>
                          <input (keyup)="onOTPKeyUp($event)" class="form-control border-form-control" value="" placeholder="" type="text">
                       <p i18n="@@OTP Incorrect | OTP Incorrect Message" *ngIf="errorAlert">OTP incorrect, please check mobile phone and resubmit.</p>
                        </div>
                   </div>
                      <div class="center-align">
                      <button type="button" (click)="submitOTP()" class="form-control">
                        <span i18n="@@Confirm Subscription |Confirm Subscription Label">Confirm Subscription</span>
                      </button>
                    </div>
                  </form>
             </div>
          </div>
    </div>
    </div>
 </section>
 </div>